import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import { useTranslation } from '../../../common/LocalizationProvider';
import { fNumber } from '../../../common/utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.warning.dark,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

AppFlight.propTypes = {
  summary: PropTypes.array
};

export default function AppFlight({ summary }) {
  const t = useTranslation();

  const flight = summary.reduce((sum, item) => {
    sum += item.flight;
    return sum;
  }, 0);

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon="octicon:paper-airplane-24" width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fNumber(flight)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {flight === 1 ? t('DB_Flight_S') : t('DB_Flight_S')}
      </Typography>
    </RootStyle>
  );
}
